import * as React from "react";
import { forwardRef } from "react";
const SvgNftImage = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 48, height: 48, viewBox: "0 0 24 24", fill: "none", stroke: "#cfd2d6", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 3, y: 3, width: 18, height: 18, rx: 4 }), /* @__PURE__ */ React.createElement("circle", { cx: 8.5, cy: 8.5, r: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M21 15l-5-5L5 21" }));
const ForwardRef = forwardRef(SvgNftImage);
export default ForwardRef;
